import React from 'react';
import {Header} from "antd/es/layout/layout";
import {Button, Flex, Image, Typography} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {AccountButton} from "../auth/AccountButton";
import {LOGO_PNG} from "../../media";
import {Link} from "react-router-dom";

export type RpgLauncherHeaderProps = {
    disableNavigation?: boolean;
}

export const RpgLauncherHeader: React.FC<RpgLauncherHeaderProps> = ({disableNavigation}) => {
    return (
        <Header style={{minHeight: '90px', maxHeight:'90px', padding: '5px', backgroundColor: 'rgba(255,255,255,0.5)'}}>
            <div style={{borderRadius: '5px'}}>
                <Flex justify={"space-between"} align={"center"}>
                    {disableNavigation && <Image src={LOGO_PNG} alt={'logo'} preview={false} style={{maxHeight: '50px'}} />}
                    {!disableNavigation && <Link to={'/'}><Image src={LOGO_PNG} alt={'logo'} preview={false} style={{maxHeight: '50px'}} /></Link>}
                    {disableNavigation && <Typography.Title level={3}> RPG Launcher </Typography.Title>}
                    {!disableNavigation && <Link to={'/'}><Typography.Title level={3}> RPG Launcher </Typography.Title></Link>}
                    {disableNavigation ? <Button disabled icon={<UserOutlined />} /> : <AccountButton /> }
                </Flex>
            </div>
        </Header>
    );
};
